const crop_data = {
  title: `Crop/Agricultural Activity Profiles`,
  body: `Select the Crop/Agricultural Activity profile(s) to populate in the Addendum A table.`,
  table: {
    th: ["Work State", "Crop and/or Agricultural Activity"],
    td: ["work_state", "crop_agricultural_activity"],
  },
  new_profile(profile) {
    return {
      id: profile.id,
      crop_id: profile.crop_id,
      work_state: profile.crop_work_state,
      crop_agricultural_activity: profile.crop_agricultural_activity,
      crop_wage_offer: null,
      crop_per: null,
      crop_piece_rate: null,
    };
  },
};

export default crop_data;
